import ToggleButton from './ToggleButton';
import HotWaterRatioInput, { getDefaultHotWaterRatioPercent } from './HotWaterRatioInput';
import { isHotWaterConnected } from '../../clientPages/actionPlan/calculations/waterPricing';

const TEXTS = {
    faucet: { label: "Raccordé à l'eau chaude", hint: "Arrivée d'eau chaude sanitaire (sortie du ballon)" },
    shower: { label: "Raccordée à l'eau chaude", hint: "Arrivée d'eau chaude sanitaire (sortie du ballon)" },
    machine: {
        label: 'Eau chauffée',
        hint: "Par le ballon ou par la machine elle-même — comptée au prix de l'eau chaude du bâtiment",
    },
};

/**
 * Eau chaude d'un équipement (robinet, douche, machine) : raccordement (technical_data.hot_water)
 * et, s'il est raccordé, part d'eau chaude typique (technical_data.hot_water_ratio) héritée par
 * ses usages qui n'ont pas leur propre part. Non raccordé : 0 % pour tous ses usages.
 * Un équipement ancien sans hot_water suit le défaut du type (isHotWaterConnected).
 */
function HotWaterEquipmentField({ data, equipmentType, onChange }) {
    const connected = isHotWaterConnected({ equipmentType, technicalData: data });
    const typeDefault = getDefaultHotWaterRatioPercent(equipmentType);
    const hasOwnRatio = data.hot_water_ratio != null;
    const texts = TEXTS[equipmentType];

    return (
        <>
            <div className={`equip-toggle-card${connected ? ' equip-toggle-card--on' : ''}`}>
                <div className="equip-toggle-card-body">
                    <span className="equip-toggle-card-label">{texts.label}</span>
                    <span className="equip-toggle-card-hint">{texts.hint}</span>
                </div>
                <ToggleButton
                    name="hot_water"
                    value={connected}
                    onChange={(e) => onChange({ target: { name: 'hot_water', value: e.target.checked } })}
                    context="equipment"
                />
            </div>

            {connected && (
                <div className="equip-field equip-field--col">
                    <span className="equip-field-label">
                        Part d'eau chaude typique
                        <span className="hwr-inline-hint"> — reprise par les usages de cet équipement</span>
                    </span>
                    <HotWaterRatioInput
                        value={hasOwnRatio ? data.hot_water_ratio : typeDefault}
                        equipmentType={equipmentType}
                        onChange={(newValue) => onChange({ target: { name: 'hot_water_ratio', value: newValue, type: 'number' } })}
                    />
                    {hasOwnRatio && data.hot_water_ratio !== typeDefault && (
                        <button
                            type="button"
                            className="usage-hwr-edit-link hwr-reset-link"
                            onClick={() => onChange({ target: { name: 'hot_water_ratio', value: null } })}
                        >
                            Revenir à la valeur par défaut ({typeDefault} %)
                        </button>
                    )}
                </div>
            )}
        </>
    );
}

export default HotWaterEquipmentField;
